module.exports = __webpack_public_path__ + "static/media/35-6.30ff9a68.mp3";